import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { IMPERSONATION_DURATIONS_RESOURCE } from '../constants';

const impersonationAllowedDurationsService = ComposedComponent =>
  reduxFetch([
    {
      resource: IMPERSONATION_DURATIONS_RESOURCE,
      method: 'get',
      request: () => ({
        url: apiRoutes.impersonationAllowedDurations(),
      }),
    },
  ])(ComposedComponent);

export default impersonationAllowedDurationsService;
